import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import App from './App';
import store from './redux/store';
// import { PersistGate } from 'redux-persist/integration/react';

import packageFile from '../package.json';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import './index.css';
import './styles/animate.css';
import './styles/classes.scss';
import './styles/variables.scss';
import './coralogix';

// Create a client
const queryClient = new QueryClient();

if (process.env.NODE_ENV === 'production') {
	import('@sentry/react').then((Sentry) => {
		import('@sentry/tracing').then(({ BrowserTracing }) => {
			Sentry.init({
				dsn: process.env.REACT_APP_SENTRY_DSN,
				integrations: [new BrowserTracing()],
				tracesSampleRate: 0.2,
				release: APP_NAME,
			});
		});
	});
}

const APP_NAME = `${packageFile.name}@${packageFile.ver}`;

ReactDOM.render(
	<Provider store={store}>
		<QueryClientProvider client={queryClient}>
			{process.env.NODE_ENV === 'development' ? <ReactQueryDevtools initialIsOpen={false} /> : null}
			<App />
		</QueryClientProvider>
	</Provider>,
	document.getElementById('root'),
);

import('./utils').then(({ clearCacheOnNewBuild }) => {
	clearCacheOnNewBuild(packageFile['ver']);
});
// import('./serviceWorkerRegistration').then((serviceWorker) => {
// 	serviceWorker.register(packageFile.ver);
// });

import('reportWebVitals').then(({ default: reportWebVitals }) => {
	reportWebVitals(console.log);
});
